module.exports = __webpack_public_path__ + "img/1.895a1ced.png";